import React, { useState } from "react";
import { push } from "react-router-redux";
import PropTypes from "prop-types";
import { toastr } from "react-redux-toastr";
import { createIncomingQuote } from "MODULES/parts/actions/incomingQuotes";
import {
  AS_IS,
  INCIDENT_RELATED,
  INCOMING_LINE_ITEMS,
  NOT_AWAITING_REPLY,
  STANDARD
} from "MODULES/IncomingQuotes/constants";
import api from "APP_ROOT/api";
import { useCurrentUser, useDispatch } from "APP_ROOT/hooks";
import Form from "./Form";
import styles from "../../styles";

const {
  [NOT_AWAITING_REPLY]: _,
  [AS_IS]: __,
  ...quoteTypes
} = INCOMING_LINE_ITEMS.quoteType;

export default function Create({ close }) {
  const [selectedCompany, setSelectedCompany] = useState({});
  const [selectedEmail, setSelectedEmail] = useState(null);
  const { onSubmit, setSubmittedWith } = useOnSubmit(close);

  const initialValues = {
    buyer_id: useCurrentUser().id,
    incoming_quote_line_item: {
      quote_type: STANDARD,
      cost: ""
    }
  };

  const { [INCIDENT_RELATED]: _unused, ...newIQQuoteTypes } = quoteTypes;

  return (
    <div className="panel panel-default" style={styles.container}>
      <div className="panel-body">
        <button className="close" type="button" onClick={close}>
          <span>
            <i className="fa fa-close" />
          </span>
        </button>
        <h4 className="modal-title" style={styles.title}>
          Create a New Incoming Quote
        </h4>
        <Form
          close={close}
          initialValues={initialValues}
          onSubmit={onSubmit}
          setSubmittedWith={setSubmittedWith}
          quoteTypes={newIQQuoteTypes}
          selectedCompany={selectedCompany}
          selectedEmail={selectedEmail}
          setSelectedCompany={setSelectedCompany}
          setSelectedEmail={setSelectedEmail}
          modal={false}
        />
      </div>
    </div>
  );
}

Create.propTypes = {
  close: PropTypes.func.isRequired
};

// Custom hooks
function useOnSubmit(close) {
  const [submittedWith, setSubmittedWith] = useState(null);
  const dispatch = useDispatch();

  const afterCreate = (quote, sendQuote) => {
    if (sendQuote) {
      api.incomingQuotes.send(quote.id, quote).then(() => {
        toastr.success("Success", "RFQ successfully sent.");
      });
    }
    if (submittedWith === "save-and-go") {
      dispatch(push({ pathname: `/incoming-quotes/${quote.uuid}` }));
    } else {
      window.scrollTo(0, 0);
      close();
    }
  };

  const onSubmit = data => dispatch(createIncomingQuote(data, afterCreate));

  return { onSubmit, setSubmittedWith };
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/IncomingQuotes/Create/Create.jsx